import React, { useContext, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppContext } from '../../context';

export default function Training() {
  const { hasPermission, enforcePermissions, setCurrentModule, currentOrganizationId } = useContext(AppContext);

  const getDefaultRoute = () => {
    // TODO: Implement default route
    return <Navigate to='/dashboard' />;
  };

  useEffect(() => {
    setCurrentModule('training');
  }, [setCurrentModule]);

  return (
    <Routes>
      <Route
        path=''
        element={getDefaultRoute()}
      />
      <Route
        path='test'
        element={<div>Test</div>}
      />
    </Routes>
  );
}
